<template>
  <article class="support-block" @click="$emit('go')">
    <p class="typo-body2 message">
      <slot name="message"></slot>
    </p>
    <div class="action flex-v-center">
      <slot name="action"></slot>
      <span class="goto">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.5 8H15.5" stroke="#0E3C82" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M8.5 15L15.5 8L8.5 1"
            stroke="#0E3C82"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </article>
</template>

<script>
export default {
  name: "SupportBlock"
};
</script>

<style lang="scss" scoped>

.support-block {
  padding: 16px 24px 24px 24px;
  background: #fff;
  border-radius: 10px;
  min-height: calc(137px - 24px - 16px);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.2s;
  // 312x137

  &:hover {
    box-shadow: 0 7px 64px rgba(0, 24, 46, 0.15);
  }

  &:not(:first-child) {
    margin-top: 24px;
  }

  > .message {
    margin-bottom: 16px;
  }

  > .action {
    margin-top: auto;
    color: $cSecondary3;
    cursor: pointer;

    > svg {
      margin-right: 8px;
    }
    .goto {
      margin-left: auto;
      align-items: center;
      display: flex;
      flex-direction: row;
    }
  }
}
</style>
